import {
  highlightText,
  InlineNodes,
  NodeSchema,
  TextColour,
  TextNodeSchema,
  toLinkContent,
} from '@principle-theorem/editor';

export class CampaignTemplateHelpers {
  static highlight(text: string): TextNodeSchema {
    const principleYellow = '#f4c018';
    return highlightText(text, principleYellow as TextColour);
  }

  static phoneLink(
    phoneNumber: string
  ): NodeSchema<InlineNodes.Link, InlineNodes.Text> {
    return toLinkContent(phoneNumber, `tel:${phoneNumber.replace(/\s+/g, '')}`);
  }
}
